import { graphql } from '@teachino/shared-infrastructure';

export const createPublicStudentLinkMutation = graphql(`
  mutation CreatePublicStudentLink($courseId: String!) {
    createCoursePublicAccess(courseIdInput: { id: $courseId }) {
      coursePublicAccess {
        id
        code
      }
    }
  }
`);
